import React from 'react'
import { Skeleton } from '@mui/material'

// Match CreativeCard's media, two-line name, and preview footer in rem units,
// so the placeholder follows the same sizing when the page font size changes.
export const CreativeCardSkeleton = () => (
  <div
    aria-hidden="true"
    className="flex h-full min-w-0 w-full flex-col overflow-hidden rounded-xl border border-mm-neutral-1-200 bg-white"
  >
    <Skeleton variant="rectangular" height="16rem" className="w-full" />
    <div className="flex-1 px-4 py-3">
      <div className="flex h-10 flex-col justify-center gap-2">
        <Skeleton variant="rectangular" height="0.75rem" width="80%" />
        <Skeleton variant="rectangular" height="0.75rem" width="55%" />
      </div>
    </div>
    <div className="mt-auto flex items-center gap-3 px-4 pb-3">
      <div className="flex h-8 items-center">
        <Skeleton variant="rectangular" height="0.75rem" width="5rem" />
      </div>
      <Skeleton variant="rectangular" height="0.75rem" width="5rem" className="ml-auto" />
    </div>
  </div>
)
